import {
  Approval,
  UpdateApprovalPayload,
  CreateApprovalPayload,
} from 'api/approval';
import { HttpClient } from '../http-client';
import { Task } from '.';

interface ApprovalResponse {
  [key: Task['taskId']]: Approval[];
}

class TaskApprovalHttpClient extends HttpClient {
  public async getApprovalList(
    projectId: number,
    taskId: number,
  ): Promise<Approval[]> {
    return this.get<Approval[]>(
      `/projects/${projectId}/tasks/${taskId}/approvals`,
    );
  }

  public async getApproval(projectId: number): Promise<ApprovalResponse> {
    return this.get<ApprovalResponse>(`/projects/${projectId}/tasks/approvals`);
  }

  public async updateApproval(
    projectId,
    taskId,
    approvalId,
    payload: UpdateApprovalPayload,
  ): Promise<Approval> {
    return this.put(
      `projects/${projectId}/tasks/${taskId}/approvals/${approvalId}`,
      payload,
    );
  }

  public async createApproval(
    projectId,
    taskId,
    payload: CreateApprovalPayload,
  ): Promise<Approval> {
    return this.post(
      `projects/${projectId}/tasks/${taskId}/approvals`,
      payload,
    );
  }

  public async deleteApproval(projectId, taskId, approvalId): Promise<void> {
    return this.delete(
      `projects/${projectId}/tasks/${taskId}/approvals/${approvalId}`,
    );
  }
}

export const TaskApprovalAPI = new TaskApprovalHttpClient();
